import { render, staticRenderFns } from "./GlobalStats.vue?vue&type=template&id=8d3b4fb6&"
import script from "./GlobalStats.vue?vue&type=script&lang=js&"
export * from "./GlobalStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports